import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendingUp, Users, Link as LinkIcon } from 'lucide-react';
import { LinksAnalytics } from '../../services/linksService';

interface LinksMetricsProps {
  analytics: LinksAnalytics;
  totalLinks: number;
  totalClicks?: number;
}

const LinksMetrics: React.FC<LinksMetricsProps> = ({ analytics, totalLinks, totalClicks }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 mb-8">
      {/* Metrics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Total Clicks */}
        <div className="bg-white rounded-xl border border-black p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">
                {t('links.analytics.totalClicks', 'Total Clicks')}
              </p>
              <p className="text-2xl font-bold text-gray-900 mt-1">
                {(totalClicks ?? analytics.totalClicks).toLocaleString()}
              </p>
            </div>
            <div className="p-3 bg-primary-50 rounded-lg">
              <TrendingUp className="w-6 h-6 text-primary-600" />
            </div>
          </div>
        </div>

        {/* Unique Users */}
        <div className="bg-white rounded-xl border border-black p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">
                {t('links.analytics.uniqueUsers', 'Unique Users')}
              </p>
              <p className="text-2xl font-bold text-gray-900 mt-1">
                {analytics.uniqueUsers.toLocaleString()}
              </p>
            </div>
            <div className="p-3 bg-green-50 rounded-lg">
              <Users className="w-6 h-6 text-green-600" />
            </div>
          </div>
        </div>

        {/* Total Links */}
        <div className="bg-white rounded-xl border border-black p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">
                {t('links.analytics.totalLinks', 'Total Links')}
              </p>
              <p className="text-2xl font-bold text-gray-900 mt-1">
                {totalLinks.toLocaleString()}
              </p>
            </div>
            <div className="p-3 bg-blue-50 rounded-lg">
              <LinkIcon className="w-6 h-6 text-blue-600" />
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default LinksMetrics; 